import { trackEvent } from '@/infra/tracking/analytics'
import { safeTrackCall } from '@/presentation/pages/common-analytics'

export namespace Analytics {
  export const trackNavigate = safeTrackCall(async (destination: string) => {
    if (!destination) return

    trackEvent('up_footer_navigate', {
      destination: destination.toLowerCase()
    })
  })
}
